import {
    RangoTradeType,
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS
} from 'src/features/common/providers/rango/models/rango-api-trade-types';

import { ON_CHAIN_TRADE_TYPE } from '../../../common/models/on-chain-trade-type';

export const RANGO_ON_CHAIN_DISABLED_PROVIDERS: RangoTradeType[] = [
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.OSMOSIS_SWAP],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.OOLONG_SWAP],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE['10K_SWAP']],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.FINKUJIRA],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.SOLANA],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.JUPITER],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.SOLAR_BEAM],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.WYND],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.SUN_SWAP],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.MDEX],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.BEAM_SWAP],
    RUBIC_TO_RANGO_ON_CHAIN_PROVIDERS[ON_CHAIN_TRADE_TYPE.OKC_SWAP]
];
